export const imageGrids = {
    '1': {
      "wrapper": "grid-cols-1",
      "item": ['max-h-[220px] sm:max-h-full'],
    },
    '2': {
      "wrapper": "grid-cols-2",
      "item": ['max-h-[220px] sm:max-h-full', 'max-h-[220px] sm:max-h-full'],
    },
    '3': {
      "wrapper": "grid-cols-2",
      "item": ['row-span-2 max-h-[215px] sm:max-h-full', 'max-h-[100px] sm:max-h-[240px]', 'max-h-[100px] sm:max-h-[240px]'],
    },
    '4': {
      "wrapper": "grid-cols-2",
      "item": ['', '', '', ''],
    },
    '5': {
      "wrapper": "grid-cols-2",
      "item": ['col-span-2', '', '', '', ''],
    }
  }  
